import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Facebook = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="11" fill="white" />
    <path
      d="M23 12C23 5.92339 18.0766 1 12 1C5.92339 1 1 5.92339 1 12C1 17.4902 5.02254 22.041 10.2812 22.8669V15.1798H7.4869V12H10.2812V9.57645C10.2812 6.8198 11.9224 5.2971 14.436 5.2971C15.6398 5.2971 16.8985 5.51177 16.8985 5.51177V8.21742H15.5111C14.145 8.21742 13.7188 9.06548 13.7188 9.93528V12H16.7695L16.2816 15.1798H13.7188V22.8669C18.9775 22.041 23 17.4902 23 12Z"
      fill="#1977F3"
    />
  </SvgIcon>
));

Facebook.displayName = 'Facebook';

export default Facebook;
